<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="'simulationBuilder.KEYWORDS_SAVE_AS_PRODUCT_DEFAULT' | transloco"
  (afterClose)="handleClose()"
  (closeButtonClicked)="handleCloseButtonClick()"
>
  <div class="content">
    <span>
      {{ 'simulationBuilder.KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE' | transloco : { keywordTitle: keywordTitle, moduleName: moduleName } }}
    </span>
    <span>
      {{ 'simulationBuilder.KEYWORDS_SAVE_AS_DEFAULT_IMPACT' | transloco : { moduleName: moduleName } }}
    </span>
  </div>

  <div class="modal-actions">
    <button
      qai-button
      kind="secondary"
      size="medium"
      [disabled]="networkRequestInProgress"
      (click)="handleClose()"
    >
      {{ 'simulationBuilder.BUTTON_CANCEL' | transloco }}
    </button>
    <button
      qai-button
      kind="destructive"
      size="medium"
      [disabled]="networkRequestInProgress"
      (click)="handleConfirm()"
    >
      {{ 'simulationBuilder.BUTTON_CONFIRM' | transloco }}
    </button>
  </div>
</dialog>
